module.exports = __webpack_public_path__ + "media/images/ilustrations/urna-f2c062a287b51fc174e2b5ddbf0fcc0a.png";